import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=31a2449c&scoped=true&"
import script from "./Signature.vue?vue&type=script&lang=js&"
export * from "./Signature.vue?vue&type=script&lang=js&"
import style0 from "./Signature.vue?vue&type=style&index=0&id=31a2449c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2449c",
  null
  
)

export default component.exports